module.exports = __webpack_public_path__ + "img/contact-image.d9e9d79e.jpg";